import { DialogBox } from '../atomic/dialog';
import { DialogProps } from '../../hooks/useDialog';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

export const PhoneNumberConfirmationDialog = (
    props: DialogProps<{ phoneNumber: string }, void>
) => {
    const {
        options: { phoneNumber },
        ...rest
    } = props;
    const formattedPhoneNumber =
        parsePhoneNumberFromString(phoneNumber, 'JP')?.formatNational() ??
        phoneNumber;

    return (
        <DialogBox title="電話番号の確認" okText="この電話番号で登録" {...rest}>
            <p>SMS認証コードは次の電話番号に送信されます.</p>
            <p>
                <strong>{formattedPhoneNumber}</strong>
            </p>
            <p>電話番号に間違いはありませんか？</p>
        </DialogBox>
    );
};
